(() => {
  const main = document.getElementById('MainContent');
  if (!main || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || document.body.dataset.disableAnimations === 'true') return;

  const reveal = (section) => {
    section.classList.remove('homepage-reveal--pending');
    observer.unobserve(section);
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) reveal(entry.target);
    });
  }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

  const variants = ['rise', 'fade', 'zoom', 'curtain'];
  Array.from(main.children).forEach((section, index) => {
    if (!section.classList.contains('shopify-section')) return;
    const bounds = section.getBoundingClientRect();
    if (!bounds.height) return;
    // Keep the initial viewport and previously scrolled content visible.
    if (bounds.top < window.innerHeight) return;
    section.dataset.homepageReveal = variants[index % variants.length];
    section.classList.add('homepage-reveal--pending');
    observer.observe(section);
  });

  main.addEventListener('focusin', (event) => {
    const section = event.target.closest('.homepage-reveal--pending');
    if (section) reveal(section);
  });
  reducedMotion.addEventListener('change', (event) => {
    if (!event.matches) return;
    main.querySelectorAll('.homepage-reveal--pending').forEach(reveal);
    observer.disconnect();
  });
})();
